import {PHIEU_IN_ENDPOINT, WF_TRACKER} from "../../../../utils/Constant";
import { TypeKeHoach } from "../models/KeHoachModel";
import {CODE_KHAO_SAT} from "../../../../quan-ly-khao-sat/Components/danh-sach-ke-hoach/constants/constansKeHoach";

export const WMS_STATUS = {
  build_plan: "build_plan",
  directDownline: "directDownline",
  build_plan_approved: "build_plan_approved",
};

export const CODE_NHAP_KHO = {
  NHA_CUNG_CAP: 'X004',
  TRA_LE: 'X003',
  KHAC: 'X005',
  HOAN_TRA: 'X011',
}

export const TYPE_KE_HOACH: TypeKeHoach[] = [
  {
    name: 'Kế hoạch chỉ dạo tuyến',
    code: CODE_NHAP_KHO.NHA_CUNG_CAP,
    formVatTu: 'chidaotuyenkehoachdaotao',
    pathApi: '',
    pathApiPrint: PHIEU_IN_ENDPOINT.NHAP_KHO.NHA_CUNG_CAP,
    trackerCode: WF_TRACKER.BUILD_PLAN,
    termModelType: "directDownline"
  }
];



export const TYPE_QL_DAO_TAO = {
  KHDT:
    {
      name: 'Đăng kí đào tạo liên tục tại bệnh viện',
      code: CODE_KHAO_SAT.DAO_TAO,
      formVatTu: 'danhmucbenhvien',
      pathApi: '',
      pathApiPrint: '',
      trackerCode: WF_TRACKER.HE_HOACH_DAO_TAO,
      termModelType: ''
    }
}